import React from "react";
import { FaInstagram } from "react-icons/fa";

const InstagramButton: React.FC = () => {
  // TS-Workaround für react-icons
  const Icon = FaInstagram as unknown as React.FC<{ size?: number }>;

  return (
    <a
      href="https://www.instagram.com/abs.gmbh?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram Profil öffnen"
      className="
        fixed bottom-6 right-20 z-50
        bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600
        text-white p-4 rounded-full shadow-lg
        transition-transform duration-300 hover:scale-110"
    >
      <Icon size={26} />
    </a>
  );
};

export default InstagramButton;
